module.exports = __webpack_public_path__ + "static/media/radio-button-selected.d2f6ec39.svg";